<template>
    <div class="leaderboard-main">
        <div class="title">
            <span>User Ranks</span>
            Leadership Board</div>
        <q-card class="no-shadow">
        <q-tabs
          v-model="tab"
          content-class="items-tabs"
          class="text-grey"
          active-color="primary"
          indicator-color=""                    
          narrow-indicator
        >
          <q-tab name="Elementary-Level" label="Elementary Level" />
          <q-tab name="Jonin-Level" label="Junior Level" />
          <q-tab name="Senior-Level" label="Senior Level" />
        </q-tabs>

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="Elementary-Level" class="Elementary-Level">
            <div v-if="tab === 'Elementary-Level'" class="board-bg">
                <!-- <img src="@/assets/img/home/leader-board.png"> -->
                <LeaderboardTable :tab="tab"/>
            </div>
          </q-tab-panel>

          <q-tab-panel name="Jonin-Level" class="Jonin-Level">
            <div v-if="tab === 'Jonin-Level'" class="board-bg">
              <LeaderboardTable :tab="tab"/>
            </div>
          </q-tab-panel>

          <q-tab-panel name="Senior-Level" class="Senior-Level">
            <div v-if="tab === 'Senior-Level'" class="board-bg">
              <LeaderboardTable :tab="tab"/>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </div>
</template>
<script>
import LeaderboardTable from './LeaderboardTable';
export default {
  components: {LeaderboardTable},
  data () {
    return {
      tab: 'Elementary-Level'
    }
  },
  methods: {

  }
}
</script>>
<style>
    .leaderboard-main{ width: 100%; display: block;}
    .leaderboard-main .title{ font-size: 40px; color: #252634; font-weight: 500; padding: 30px 8%;}
    .leaderboard-main .title span{ font-size: 13px; color: #0093D2; font-weight: 500; display: block;}
    .leaderboard-main .items-tabs{ justify-content: space-between !important; padding: 0 3%;}
    .q-hoverable:hover > .q-focus-helper, .q-focusable:focus .q-focus-helper, .q-ripple{ background: none !important; opacity:0 !important;}     
    .q-focusable:focus { background: none !important;}     
    .leaderboard-main .q-tab .q-tab__label{ width: 290px; height: 90px; line-height: 90px; color:#96969d; border-radius: 90px; font-size: 20px; font-weight: 500 !important; text-transform: none;}
    .leaderboard-main .q-tab .q-tab__indicator{width: 100%; height: 50px; position: relative; top:0; }
    .leaderboard-main .q-tab--active .q-tab__label{ background-color: var(--mainColors); color: white;}
    .leaderboard-main .q-tab--active .q-tab__indicator{ width: 100%; height: 50px; position: relative; top:0; background-image:url("~@/assets/img/home/tab-pointer.png"); background-repeat: no-repeat; background-position: center -65px; background-color: transparent !important; margin: 0px 0 0px 0;}
        
    .q-tab-panel{padding: 0 !important;}      

    .q-tab__content{padding: 0 !important;}
    .leaderboard-main .board-bg{ width:auto; float: left; background-image:url("~@/assets/img/home/leaderboard-bg.png"); background-repeat: no-repeat; background-position: center top; background-size: 100% 100%; padding: 40px 50px 50px 80px;}
    .leaderboard-main .Jonin-Level .board-bg{ margin-left: 10%;}
    .leaderboard-main .Senior-Level .board-bg{ float: right;}

    
    @media (max-width: 1079px) {
      .leaderboard-main .q-tab .q-tab__label{width: 220px; height: 70px; line-height: 70px; font-size: 18px;}
      .leaderboard-main .q-tab .q-tab__indicator{height: 40px;}
      .leaderboard-main .board-bg { padding: 30px 30px 30px 40px;}
    }
    
    @media (max-width: 767px) {
      .leaderboard-main .title{ font-size: 28px; padding: 30px 0;}      
      .leaderboard-main .q-tab .q-tab__label{width: auto; height: 50px; line-height:12px; font-size: 14px; padding: 12px 14px; white-space: break-spaces;}
      .q-tab {padding: 0 6px !important;}
      .leaderboard-main .board-bg{ background: var(--mainColors); border-radius: 30px;}
    }
   
    </style>